/** @format */
import { MarketLanguage } from '@mpb-com/feather/enums';

import { languagesWithImpressum } from '@toucan/client/global/market/config/language';

export const hasImpressum = (language: MarketLanguage) => {
    return languagesWithImpressum.includes(language);
};
